export const safeParseJson = (jsonString?: string | null) => {
    if (!jsonString) {
        return null;
    }

    try {
        return JSON.parse(jsonString);
    } catch {
        return null;
    }
};

export const safeParseInt = (numberString: string) => {
    try {
        const parsed = Number.parseInt(numberString, 10);

        return Number.isNaN(parsed) ? null : parsed;
    } catch {
        return null;
    }
};
